export enum OrderType {
  PURCHASE_ORDER = <any> 'O',
  PURCHASE_REQUEST = <any>'S',
  MATERIALS_REQUISITION = <any> 'R',
  PURCHASE_QUOTATION = <any> 'C',
  INVOICE = <any> 'N',
  BID_RECORD = <any> 'L',
  CONTRACT = <any> 'G'
}

export function findEnum(value: string): string {
  return Object.keys(OrderType)[Object.values(OrderType).indexOf(value)];
}
